export type LegacyMediaQueryList = MediaQueryList & {
  addListener?: (listener: (event: MediaQueryListEvent) => void) => void
  removeListener?: (listener: (event: MediaQueryListEvent) => void) => void
}

export function matchesMedia(query: string): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false
  return window.matchMedia(query).matches
}

/**
 * Android System WebView'in eski sürümleri yalnız addListener/removeListener
 * sunar. Bir seçici render edilirken bu farkın uygulamayı düşürmemesi için iki
 * MediaQueryList sözleşmesini de destekle.
 */
export function subscribeMediaQuery(
  query: string,
  listener: (matches: boolean) => void,
): () => void {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return () => undefined

  const media = window.matchMedia(query) as LegacyMediaQueryList
  const update = (event?: MediaQueryListEvent) => listener(event?.matches ?? media.matches)

  if (typeof media.addEventListener === 'function') {
    media.addEventListener('change', update)
    return () => media.removeEventListener?.('change', update)
  }
  if (typeof media.addListener === 'function') {
    media.addListener(update)
    return () => media.removeListener?.(update)
  }
  return () => undefined
}
